import {getSingleInputByNameV3} from "../../../helpers/forms/formInputsHelpers";
import Axios from "axios";
import {loading, stopLoading} from "../../../helpers/loading";
import handleAjaxErrorV2 from "../../../helpers/handleAjaxErrorV2";
import {displayLocalValidationError} from "../../../helpers/forms/validationErrors/utils";

class TotalPreviewComponent {

    /** @var {HTMLInputElement} */
    discountCodeInput;

    /**
     * @param {HTMLElement} container
     * @param {GlobalState} state
     */
    constructor(container, state) {
        this.container = container
        this.state = state;

        this.getTotalsPreviewHtmlRoute = getSingleInputByNameV3(document.body, 'get_totals_preview_html_route');
    }

    async updateTotalsFromServer() {
        // Get new total HTML
        try {
            const result = await Axios.post(
                this.getTotalsPreviewHtmlRoute,
                this.state.getOrderDataForServer()
            );

            // Append to container
            this.container.innerHTML = result.data.body;

            // Initialize components
            this.getDiscountRoute = getSingleInputByNameV3(this.container, 'get_discount_route');
            this.eventId = getSingleInputByNameV3(this.container, 'event_id');
            this.discountCodeAccepted = getSingleInputByNameV3(this.container, 'discount_code_accepted') === '1';

            // Init discount code input
            this.discountCodeInput = this.container.querySelector('input[name="discount_code"]');

            if (this.state.discountCode) {
                // If discount code is no longer valid
                if (this.discountCodeAccepted === false) {
                    // Let the user know
                    displayLocalValidationError(document.body, 'DUMMY', 'Discount code no longer applies to this order')
                    // And clear state
                    this.state.setDiscountCode('');
                    // And refresh view
                    this.updateTotalsFromServer().then();
                } else {
                    this.discountCodeInput.value = this.state.discountCode;
                }
            }

            this.discountCodeInput.addEventListener('keyup', e => {
                if (e.key === 'Enter') {
                    this.handleDiscountCodeUseRequest();
                }
            })

            // Setup event handlers
            this.container.querySelector('.use-discount-code-button')
                .addEventListener('click', () => {
                    this.handleDiscountCodeUseRequest()
                })
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errors) {
                const validationErrors = error.response.data.errors

                // There was an error with the discount
                if (validationErrors.discount) {
                    // Let the user know
                    displayLocalValidationError(document.body, 'DUMMY', 'Discount code no longer applies to this order')
                    // And clear state
                    this.state.setDiscountCode('');
                    // And refresh view
                    this.updateTotalsFromServer().then();

                }
            }
        }
    }

    handleDiscountCodeUseRequest() {
        const discountCode = this.discountCodeInput.value.trim();

        if (discountCode) {
            loading();

            // Test if discount is valid
            Axios.post(this.getDiscountRoute, {
                event_id: this.eventId,
                code: discountCode,
                ...this.state.getOrderDataForServer(),
            })
                .then(() => {
                    this.state.setDiscountCode(discountCode)
                })
                .catch(error => {
                    this.state.setDiscountCode('');
                    handleAjaxErrorV2(error)
                })
                .finally(() => {
                    stopLoading();
                    // Refresh totals
                    this.updateTotalsFromServer().then();
                })
        } else {
            // Clear discount
            this.state.setDiscountCode('');
            // Refresh totals
            this.updateTotalsFromServer().then();
        }

    }
}

export {TotalPreviewComponent}
